import React from 'react';
import './index.scss';
import { Method } from '@/fetch/core/util';
import { useSelector } from 'react-redux';
import { RootState } from '@/redux/store';
import { request } from '@/fetch/core';
import { HttpStatusCode } from '@/fetch/core/constant';
import { message } from 'antd';
import { getClstag } from '@/utils/util';
const RemoveStop = (props: {
  vehicleName: string;
  cockpitNumber: string;
  takeOverBySelf: boolean;
  closeDropdown: () => void;
}) => {
  const { login, newCommon } = useSelector((state: RootState) => state);
  const handleRemoveStop = () => {
    const { cockpitNumber, vehicleName, takeOverBySelf } = props;
    if (
      !login.userInfo?.userName ||
      !cockpitNumber ||
      !vehicleName ||
      !takeOverBySelf
    ) {
      return;
    }
    const requestData: RequestOptions = {
      path: '/monitor/web/drive/command/send/relieve-button-stop',
      method: Method.POST,
      body: {
        cockpitNumber,
        vehicleName,
        cockpitUserName: login.userInfo?.userName,
      },
    };
    request(requestData).then((res: any) => {
      if (res.code === HttpStatusCode.Success) {
        message.success('指令下发成功');
        props.closeDropdown();
      } else {
        message.warning(res.message || '指令下发失败');
      }
    });
  };

  return (
    <>
      <button
        className="vehicle-command-btn"
        disabled={!props.takeOverBySelf}
        onClick={handleRemoveStop}
        clstag={
          props.takeOverBySelf
            ? getClstag(newCommon.cockpitMode, 'SinglePage_RemoveStop')
            : ''
        }
      >
        解除拍停
      </button>
    </>
  );
};

export default React.memo(RemoveStop);
